import React from "react";
import { window } from "global";
import { useGlobal } from "reactn";
import { MediaQuery } from "@outplayed/responsive";
import { ReactComponent as BlueManPlus } from "svg/blue-man-plus.svg";
import { ReactComponent as SearchIconWhite } from "svg/search-icon-2-white.svg";
import { ReactComponent as SearchIconWhiteLightMode } from "svg/search-icon-2-light-mode.svg";
import { ReactComponent as UggLogoU } from "svg/logos/ugg-u-logo.svg";
import { ReactComponent as FullUggLogo } from "../svg/logos/ugg-logo-blue.svg";
import { ReactComponent as HamburgerMenu } from "svg/hamburger-menu.svg";
import { ReactComponent as DownloadCloudFill } from "svg/download-cloud-fill.svg";
import FeedbackIcon from "./Masthead/Feedback/FeedbackIcon";
import Searchbar from "./Searchbar";
import { useLightMode } from "hooks/general-hooks";
import LightModeToggle from "./Masthead/LightModeToggle";
import NotificationContainer from "./Masthead/Notifications/NotificationContainer";
import { LoginButton } from "components/Accounts/Login";
import classNames from "classnames";
import { ReactComponent as EchoLogo } from "svg/echoLogo.svg";
import { Link } from "react-router-dom";

const Masthead = (props) => {
  const { sideNavOpen, setSideNavOpen, setAutoSearch } = props;
  const [loggingIn] = useGlobal("loggingIn");
  const [authToken] = useGlobal("authToken");
  const [verificationBar] = useGlobal("verificationBar");
  const { lightModeOn } = useLightMode();

  const collapsed = sideNavOpen ? "expanded" : "collapsed";

  // We are removing user link stuff until after launch
  const renderUserLink = () => {
    if (!window || loggingIn) {
      return null;
    } else if (authToken) {
      return <UserProfileLink />;
    } else {
      return (
        <div className="masthead_account-buttons">
          <LoginButton>
            <div className="btn-blue btn-blue_hover" style={{ height: "40px", width: "100px" }}>
              Log In
            </div>
          </LoginButton>
        </div>
      );
    }
  };

  const autoSearch = () => {
    setAutoSearch(true);
    setSideNavOpen(true);
  };

  const verificationBarActive = verificationBar ? "verification-bar-active" : "";

  if (!window) {
    return (
      <div id="masthead" className={`${props.isLandingPage ? "landing transparent" : ""}`}>
        <div className={`masthead-container`}></div>
      </div>
    );
  }

  return (
    <div id="masthead" className={`${verificationBarActive} ${props.isLandingPage ? "landing transparent" : ""}`}>
      <div className={"masthead-container " + collapsed}>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
          <div className="mobile-logo">
            <HamburgerMenu className="hamburger" onClick={() => setSideNavOpen(!sideNavOpen)} />
            <a href="https://u.gg">
              <div className="masthead-ugg-logo">
                <UggLogoU style={{ height: "38px", width: "19.19px" }} />
              </div>
            </a>
          </div>
        </MediaQuery>
        {props.isLandingPage && (
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <a className="masthead_app-download-btn" href="/app?utm_source=uggtop&game=wow">
              <DownloadCloudFill style={{ width: "16px", height: "16px" }} />
              <span>Download Now</span>
            </a>
          </MediaQuery>
        )}
        <div
          className={classNames("masthead-search-bar-container", {
            "dark-theme": !lightModeOn,
            "light-theme": lightModeOn,
          })}
        >
          {!props.isLandingPage && <Searchbar placeholder={"Search Class and Spec"} />}
        </div>
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          <div className="masthead-right">
            <LightModeToggle />
            {/* <SettingsContainer /> */}
            {/* <div className="echo-masthead-icon">
              <Link to="/wow/echo">
                <EchoLogo width="14px" />
              </Link>
            </div> */}
            <div className="flex items-center gap-1.5">
              <FeedbackIcon />
              <NotificationContainer />
            </div>
          </div>
        </MediaQuery>
        <MediaQuery min="MOBILE_LARGE" max="MOBILE_LARGE">
          <div className="masthead-right" style={{ marginLeft: "-16px" }}>
            {/* <SettingsContainer /> */}
            {/* <div className="echo-masthead-icon">
              <Link to="/wow/echo">
                <EchoLogo width="14px" />
              </Link>
            </div> */}
            <div className="flex items-center gap-1.5">
              <FeedbackIcon />
              <NotificationContainer />
            </div>
          </div>
        </MediaQuery>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
          <div className="masthead-right" style={{ marginLeft: "-16px" }}>
            {!props.isLandingPage &&
              (lightModeOn ? (
                <SearchIconWhiteLightMode style={{ height: "16px", width: "16px" }} onClick={autoSearch} />
              ) : (
                <SearchIconWhite style={{ height: "16px", width: "16px" }} onClick={autoSearch} />
              ))}
            {/* <SettingsContainer /> */}
            {/* <div className="echo-masthead-icon">
              <Link to="/wow/echo">
                <EchoLogo width="14px" />
              </Link>
            </div> */}
            <div className="flex items-center gap-1.5">
              <FeedbackIcon />
              <NotificationContainer />
            </div>
          </div>
        </MediaQuery>
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          {/* <div className="masthead_account">{renderUserLink()}</div> */}
        </MediaQuery>
        {/* <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
          <div className="masthead_blue-man">
            <Link to={"/login"}>
              <BlueManPlus />
            </Link>
          </div>
        </MediaQuery> */}
      </div>
    </div>
  );
};

export default Masthead;
